import React from "react";
import blogImage1 from "../../../Assets/Homeimgs/blog1.png";
import blogImage2 from "../../../Assets/Homeimgs/blog2.png";
import blogImage3 from "../../../Assets/Homeimgs/blog3.png";
import img1 from "../../../Assets/Homeimgs/react.svg";
import img2 from "../../../Assets/Homeimgs/db.svg";
import img3 from "../../../Assets/Homeimgs/javascript.svg";
import img4 from "../../../Assets/Homeimgs/tailwind.svg";
import img5 from "../../../Assets/Homeimgs/node.svg";
import img6 from "../../../Assets/Homeimgs/python.svg";
import img7 from "../../../Assets/Homeimgs/jupyter.svg";
import img8 from "../../../Assets/Homeimgs/flask.svg";
import img9 from "../../../Assets/Homeimgs/figma.png";
import img10 from "../../../Assets/Homeimgs/canva.svg";
import { useNavigate } from "react-router-dom";

const blogs = [
  {
    image: blogImage1,
    tag: "Web Development",
    title: "Build Modern Websites with Confidence",
  },
  {
    image: blogImage2,
    tag: "Career Tips",
    title: "Kickstart Your Tech Journey the Right Way",
  },
  {
    image: blogImage3,
    tag: "Trending Tech",
    title: "Stay Ahead with the Latest Tech Trends",
  },
];

const techLogos = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10];

const LatestTechBlogs = () => {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 py-12 lg:py-16">
      {/* Background */}
      <div className="pointer-events-none absolute inset-0 opacity-40">
        <div className="absolute -left-24 top-0 h-72 w-72 rounded-full bg-[#064585]/40 blur-3xl" />
        <div className="absolute -right-24 bottom-0 h-72 w-72 rounded-full bg-[#5989C8]/30 blur-3xl" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-12">
          <p
            className="inline-flex items-center justify-center px-4 py-1 rounded-full bg-white/5 border border-white/10 text-xs sm:text-sm text-[#5989C8] font-medium backdrop-blur-md"
            data-aos="zoom-out-right"
          >
            Latest Insights
          </p>
          <h1 className="text-2xl mt-4 md:text-4xl font-semibold text-white">
            Latest{" "}
            <span className="bg-gradient-to-r from-[#64a2ff] to-[#064585] bg-clip-text text-transparent">
              Tech
            </span>{" "}
            Blogs
          </h1>
          <p
            className="mt-4 text-sm md:text-base text-slate-300/90 tracking-wide md:max-w-[60%] mx-auto"
            data-aos="zoom-out-left"
          >
            Stay updated with in-depth articles on emerging technologies,
            industry trends, and practical career insights—curated for students
            and professionals who want to stay ahead.
          </p>
        </div>

        {/* Blog Cards */}
        <div
          className="grid gap-6 md:gap-8 grid-cols-1 md:grid-cols-3"
          data-aos="zoom-in-up"
        >
          {blogs.map((blog, index) => (
            <article
              key={index}
              className="group relative rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md overflow-hidden shadow-xl shadow-slate-950/40 hover:-translate-y-1 hover:border-[#5989C8]/70 transition-all duration-200"
            >
              <div className="relative overflow-hidden">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="h-52 w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  data-aos="zoom-in-right"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent opacity-70" />
                <span className="absolute left-4 top-4 inline-flex items-center rounded-full bg-slate-900/80 border border-white/10 px-3 py-1 text-xs font-medium text-slate-100">
                  {blog.tag}
                </span>
              </div>

              <div className="relative p-5 sm:p-6 flex flex-col gap-3">
                <h2 className="text-lg md:text-xl font-semibold text-white leading-snug">
                  {blog.title}
                </h2>
                <p className="text-sm text-slate-300/90">
                  Discover practical tips, real-world examples, and step-by-step
                  guidance to level up your skills with Web_Bocket Classes.
                </p>

                <div className="mt-2 flex items-center justify-between text-xs text-slate-400">
                  <button
                    className="inline-flex items-center gap-1 text-[#64a2ff] font-medium group-hover:underline"
                    onClick={() => {
                      navigate(`/articles/${blog.id}`);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                  >
                    Read Blog
                    <span className="text-sm group-hover:translate-x-0.5 transition-transform">
                      →
                    </span>
                  </button>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Technology Section */}
        <div className="mt-14 md:mt-16 text-center" data-aos="zoom-in-down">
          <h2
            className="text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-wide md:max-w-[55%] mx-auto"
            data-aos="zoom-in"
          >
            Technologies You Learn To Accelerate Your Career Growth
          </h2>

          {/* SLIDER WRAPPER */}
          <div className="mt-8 md:mt-10 overflow-hidden w-[90%] md:w-[80%] mx-auto">
            <div className="flex gap-6 animate-slide-infinite py-2">
              {[...techLogos, ...techLogos].map((logo, index) => (
                <div
                  key={index}
                  className="group rounded-2xl bg-white/5 border border-white/10 backdrop-blur-md px-3 py-3 
          flex items-center justify-center shadow-lg shadow-slate-950/40 
          hover:-translate-y-1 hover:border-[#5989C8]/70 transition-all duration-200 min-w-[120px]"
                >
                  <img
                    src={logo}
                    alt=""
                    className="max-h-10 md:max-h-12 w-auto object-contain mx-auto"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LatestTechBlogs;
